import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/order"

class service {

    changeCodeLabel(form) {
        return http.post(path + "/changeCodeLabel", form)
    }

    reverse(id) {
        return http.get(path + "/reverse-finish/" + id)
    }

    reinstall(id) {
        return http.get(path + "/reinstall/" + id)
    }

    reprocessed(productionOrderId,reprocessedParentProductionOrderId) {
        return http.get(path + "/reprocessed/" + productionOrderId + "/" + reprocessedParentProductionOrderId)
    }


    consistenceLotByIssueDateAndGroupProduct(lotId, issueDate, groupProductId) {

        return http.get(path + "/consistenceLotByIssueDateAndGroupProduct/?lotId=" + lotId + "&issueDate=" + issueDate + "&groupProductId=" + groupProductId)

    }
}

export default new service();


